// components/extras/ExtraSummaryCard.js
// Card riepilogo totali per categoria e note generali

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Calculator } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

const ExtraSummaryCard = ({
  categoriesWithItems,
  categoryTotals,
  grandTotal,
  formData,
  setFormData
}) => {
  return (
    <Card className="card-abitalo">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Calculator className="w-5 h-5 text-[#FF7819]" />
          Riepilogo Extra
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2" data-testid="extra-summary">
          {categoriesWithItems.map(cat => (
            <div key={cat.code} className="flex justify-between py-2 border-b border-[#F2F2F2]">
              <span className="text-[#3C3C3C]">{cat.code} - {cat.label}</span>
              <span className="font-medium">
                {formatCurrency(categoryTotals[cat.code])}
              </span>
            </div>
          ))}
          <div className="flex justify-between py-3 border-t-2 border-[#FF7819]">
            <span className="text-lg font-semibold">TOTALE EXTRA</span>
            <span className="text-xl font-bold text-[#FF7819]" data-testid="summary-grand-total">
              {formatCurrency(grandTotal)}
            </span>
          </div>
        </div>

        {/* General Notes */}
        <div className="mt-6">
          <Label htmlFor="notes">Note generali</Label>
          <Textarea
            id="notes"
            value={formData.notes || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, notes: e.target.value }))}
            placeholder="Note generali per questo extra..."
            rows={3}
            className="mt-1"
            data-testid="general-notes-textarea"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ExtraSummaryCard;
